module.exports = __webpack_public_path__ + "media/images/musician-noregister-07b1205578ee4936780b8b77c97a5fa6.png";